// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"49af86ba","610":"d56122a3","927":"e8d0e424"}[chunkId] + ".css";
};